import React from 'react'
import { Link } from 'react-router-dom'

const iconClass = 'h-5 w-5 sm:h-7 sm:w-7'

const ContactIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0l-7.5-4.615A2.25 2.25 0 012.25 6.993V6.75" />
  </svg>
)

const Navbar = ({ onHomeClick }) => {
  return (
    <nav className="bg-gray-900 text-white w-full">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between flex-nowrap py-2 bg-[#101624] min-w-0">
          {/* Logo and Title */}
          <Link
            to="/"
            className="flex items-center gap-1 sm:gap-2 min-w-0 hover:opacity-80 transition-opacity"
            onClick={onHomeClick}
          >
            <img src="/images/thetechnerd.svg" alt="The Tech Nerd" className="h-7 w-7 sm:h-8 sm:w-8" />
            <span className="font-bold text-base sm:text-xl whitespace-nowrap truncate">The Tech Nerd</span>
          </Link>
          {/* Social Icons and Contact */}
          <div className="flex items-center gap-2 sm:gap-4 flex-nowrap">
            <a href="https://tiktok.com/@thetechnerd.co" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <img src="/images/icons/tiktok.svg" alt="" className={iconClass} draggable="false" />
            </a>
            <a href="https://www.instagram.com/thetechnerd.co" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <img src="/images/icons/instagram.svg" alt="" className={iconClass} draggable="false" />
            </a>
            <a href="https://www.youtube.com/@thetechnerdco" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <img src="/images/icons/youtube.svg" alt="" className={iconClass} draggable="false" />
            </a>
            <a href="mailto:contact@thetechnerd.co" className="bg-blue-600 hover:bg-blue-700 text-white px-2 py-1 sm:px-4 sm:py-2 rounded-md font-semibold transition-colors ml-1 sm:ml-2 flex items-center">
              <span className="hidden sm:inline">Contact</span>
              <span className="sm:hidden">
                <ContactIcon />
              </span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar 